import styled from "styled-components";
import { colors2 } from "oolib";

export const StyledMetricCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  min-width: 0;
  padding: 2rem;
  background: ${colors2.white};
  border-radius: 1rem;
  gap: 0.8rem;
  /* Long unbroken labels (e.g. underscore-joined field names) have no word
     boundaries to wrap on — force-break them so they never overflow the card. */
  overflow-wrap: anywhere;
  word-break: break-word;
`;

export const StyledTagsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-wrap: wrap;
`;

export const StyledTooltipBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 30rem;
  max-height: 95vh;
  overflow-y: auto;
  padding: 0.8rem;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StyledTooltipContent = styled.div<{ $isLast?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding-bottom: ${({ $isLast }) => ($isLast ? '0' : '0.8rem')};
  border-bottom: ${({ $isLast }) => ($isLast ? 'none' : `0.1rem solid ${colors2.white}4d`)};
`;